export default "__VITE_ASSET__8cf46b75__"